export default "__VITE_ASSET__BNSumcEY__"